import { createSlice, PayloadAction, createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';
import { City } from '../../types/city';

const initialState: City[] = [];

export const stateSlice = createSlice({
  name: 'state',
  initialState,
  reducers: {
    setStateCities: (_, action: PayloadAction<City[]>) => {
        return action.payload;
    },
    clearStateCities: () => initialState,
  },
});

export const {
    setStateCities,
    clearStateCities 
} = stateSlice.actions;

export default stateSlice.reducer;

const getStateCities = (state: RootState) => state.state;

export const selectStateCitiesDropdownOptions = createSelector(
  [getStateCities],
  (cities) => 
    cities.map(cityObj => ({
      value: cityObj.name,
      label: cityObj.name
    }))
);